import { useEffect, useRef } from 'react';
import { useWalkthrough } from '../useWalkthrough';
import { CREATE_MODEL_WALKTHROUGH_ID, WALKTHROUGH_STATUS } from '../registry';

/**
 * Lifecycle of the demo tour inside the demo wizard: (re)start the
 * `create_model` walkthrough from its first mark when the demo mounts, and
 * dismiss it if the user leaves the demo mid-way (Back, browser navigation),
 * so a dangling active tour never blocks the task tour from auto-starting
 * afterwards. The tour is ephemeral, so none of this
 * touches the user's saved preferences.
 */
export function useDemoTour(enabled) {
    const { active, start, end } = useWalkthrough();
    const activeRef = useRef(active);
    activeRef.current = active;
    const endRef = useRef(end);
    endRef.current = end;

    useEffect(() => {
        if (!enabled) return undefined;
        start(CREATE_MODEL_WALKTHROUGH_ID, { restart: true });
        return () => {
            if (activeRef.current === CREATE_MODEL_WALKTHROUGH_ID) {
                endRef.current(WALKTHROUGH_STATUS.dismissed, CREATE_MODEL_WALKTHROUGH_ID);
            }
        };
    }, [enabled, start]);
}

export default useDemoTour;
